// frontend_MainDashboard/src/hooks/api/useTeamApi.ts

import { useCallback } from 'react';
import { useApiBase } from './useApiBase';
import {
  TeamMembersResponse,
  TeamMemberCreatePayload,
  TeamMemberUpdatePayload,
  CreateTeamMemberResponse,
} from '@openmirror/shared';

export interface TeamApiHook {
  fetchTeamMembers: () => Promise<TeamMembersResponse>;
  createTeamMember: (payload: TeamMemberCreatePayload) => Promise<CreateTeamMemberResponse>;
  updateTeamMember: (memberId: string, payload: TeamMemberUpdatePayload) => Promise<CreateTeamMemberResponse>;
  deleteTeamMember: (memberId: string) => Promise<{ success: boolean; message?: string }>;
}

export const useTeamApi = (): TeamApiHook => {
  const { makeRequest } = useApiBase();

  const fetchTeamMembers = useCallback(async (): Promise<TeamMembersResponse> => {
    return makeRequest<TeamMembersResponse>('/client/team_members', 'GET');
  }, [makeRequest]);

  const createTeamMember = useCallback(async (payload: TeamMemberCreatePayload): Promise<CreateTeamMemberResponse> => {
    return makeRequest<CreateTeamMemberResponse, TeamMemberCreatePayload>('/client/team_members', 'POST', payload);
  }, [makeRequest]);

  const updateTeamMember = useCallback(async (memberId: string, payload: TeamMemberUpdatePayload): Promise<CreateTeamMemberResponse> => {
    return makeRequest<CreateTeamMemberResponse, TeamMemberUpdatePayload>(`/client/team_members/${memberId}`, 'PUT', payload);
  }, [makeRequest]);

  const deleteTeamMember = useCallback(async (memberId: string): Promise<{ success: boolean; message?: string }> => {
    return makeRequest<{ success: boolean; message?: string }>(`/client/team_members/${memberId}`, 'DELETE');
  }, [makeRequest]);

  return {
    fetchTeamMembers,
    createTeamMember,
    updateTeamMember,
    deleteTeamMember,
  };
};
